import React from 'react'
import { Typography } from '@material-ui/core'
import transportadorAnttRepository from './TransportadorAnttRepository'
import RequisicaoCard from '../RequisicaoCard'
import moment from 'moment'

const notNullOrUndefined = value => value !== null && value !== undefined

const TransportadorAnttCard = ({
  match,
  rntrc,
  placa,
  cpfcnpj,
  disabled,
  validateFieldName,
  rntrcEmissao
}) => {
  const transform = query => ({
    ...query,
    rntrc,
    cpfcnpj,
    placa
  })

  const validateData = data => {
    if (!data) {
      return 'ERROR'
    }

    const isRntrcAtivo = data.situacaoRntrc === 'ATIVO'

    const rntrcEmissaoFromForm = moment(rntrcEmissao)

    const cadastroDesde = moment(data.cadastroDesde).format('YYYY-MM-DD')
    const rntrcEmissaoFromFormFormated = moment(rntrcEmissao).format(
      'YYYY-MM-DD'
    )

    const isRntrcEmissaoSameAsCadastro =
      cadastroDesde === rntrcEmissaoFromFormFormated

    const twoYearsAgo = moment().subtract(2, 'years')
    const isRntrcEmissaoLessThanTwoYearsAgo = twoYearsAgo.isAfter(
      rntrcEmissaoFromForm
    )

    const messages = data.mensagens
      .map(mensagem => mensagem.descricao.toLowerCase())
      .join(',')

    const hasMessageNotInFleet = messages.includes(
      'não está cadastrado na frota do transportador informado'
    )

    const hasMessageNotAuthorized = messages.includes(
      'não está apto a realizar o transporte remunerado de cargas'
    )

    const hasMessageMissingVehicle = messages.includes(
      'por falta de veículo automotor ativo cadastrado na frota'
    )

    let message = ''

    if (!isRntrcAtivo) {
      message += 'RNTRC não está ativo. '
    }

    if (!isRntrcEmissaoSameAsCadastro) {
      message += 'Data de emissão do RNTRC é diferente da cadastrada. '
    }

    if (hasMessageNotInFleet) {
      message +=
        'Veículo não está cadastrado na frota do transportador informado. '
    }

    if (hasMessageNotAuthorized) {
      message +=
        'Transportador não está apto a realizar o transporte remunerado de cargas. '
    }

    if (hasMessageMissingVehicle) {
      message +=
        'Transportador não tem este veículo automotor ativo cadastrado na frota. '
    }

    if (isRntrcEmissaoLessThanTwoYearsAgo) {
      message += 'Data de emissão do RNTRC é menor que 2 anos.'
    }

    if (
      isRntrcAtivo &&
      isRntrcEmissaoSameAsCadastro &&
      !hasMessageNotInFleet &&
      !hasMessageNotAuthorized &&
      !hasMessageMissingVehicle
    ) {
      return { status: 'SUCCESS', message: '' }
    }

    if (
      isRntrcAtivo &&
      !isRntrcEmissaoSameAsCadastro &&
      isRntrcEmissaoLessThanTwoYearsAgo &&
      !hasMessageMissingVehicle &&
      !hasMessageNotInFleet &&
      !hasMessageNotAuthorized
    ) {
      return { status: 'WARNING', message: message.trim() }
    }

    return { status: 'ERROR', message: message.trim() }
  }

  return (
    <RequisicaoCard
      title="ANTT"
      match={match}
      repository={transportadorAnttRepository}
      transformQuery={transform}
      transformManualFetch={transform}
      disabled={disabled}
      validData={true}
      validateData={validateData}
      validateFieldName={validateFieldName}
    >
      {data => (
        <>
          {data.placa && (
            <Typography>
              <b>Placa:</b> {data.placa}
            </Typography>
          )}
          {!!data.descricao && (
            <Typography>
              <b>Transportador:</b> {data.descricao}
            </Typography>
          )}
          {!!data.municipio && (
            <Typography>
              <b>Município:</b> {data.municipio}
            </Typography>
          )}
          {!!data.uf && (
            <Typography>
              <b>UF:</b> {data.uf}
            </Typography>
          )}
          {!!data.situacaoRntrc && (
            <Typography>
              <b>RNTRC:</b> {data.situacaoRntrc}
            </Typography>
          )}
          {!!data.cadastroDesde && (
            <Typography>
              <b>Cadastro desde:</b>{' '}
              {moment(data.cadastroDesde).format('DD/MM/YYYY')}
            </Typography>
          )}
          {!!data.dataValidade && (
            <Typography>
              <b>Data validade:</b>{' '}
              {moment(data.dataValidade).format('DD/MM/YYYY')}
            </Typography>
          )}
          {notNullOrUndefined(data.aptoRealizarTransporteRemunerado) && (
            <Typography>
              <b>
                {data.aptoRealizarTransporteRemunerado
                  ? 'Está apto a realizar transporte remunerado'
                  : 'Não está apto a realizar transporte remunerado'}
              </b>
            </Typography>
          )}
          {notNullOrUndefined(data.enquadradoArtigo5A) && (
            <Typography>
              <b>
                {data.enquadradoArtigo5A
                  ? 'Está enquadrado no artigo 5A'
                  : 'Não está enquadrado no artigo 5A'}
              </b>
            </Typography>
          )}
          {data.veiculo && (
            <>
              <Typography>
                <b>
                  <i>Veículo</i>
                </b>
              </Typography>
              {data.veiculo.tipoVeiculo && (
                <Typography>
                  <b>Tipo veículo:</b> {data.veiculo.tipoVeiculo}
                </Typography>
              )}
              {data.veiculo.identificacaoEletronicaTag && (
                <Typography>
                  <b>Identificação eletrônica:</b>{' '}
                  {data.veiculo.identificacaoEletronicaTag}
                </Typography>
              )}
            </>
          )}
          {!!data.mensagens.length && (
            <>
              <Typography>
                <b>
                  <i>Mensagens</i>
                </b>
              </Typography>
              {data.mensagens.map((mensagem, index) => (
                <Typography key={index}>
                  {index + 1}. {mensagem.descricao}
                </Typography>
              ))}
            </>
          )}
        </>
      )}
    </RequisicaoCard>
  )
}

export default React.memo(TransportadorAnttCard)
